import { render } from "./CreditsView.vue?vue&type=template&id=a6063c34"
import script from "./CreditsView.vue?vue&type=script&lang=js"
export * from "./CreditsView.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2009374271/src/sayuri/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__